import { FC, memo } from 'react';
import LogoImg from '@/assets/images/logo.webp';
import { Image } from 'antd-mobile';
const Index: FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-bar" />
      <Image className="logo" src={LogoImg} />
    </div>
  );
};
export default memo(Index);
